var DEFAULT_EL;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DEFAULT_EL = '.featured-image';

DealCarousel.Helpers = {
  getMedia: function(carousel) {
    var dealImages, dealVideos, forceVideos, media, showVideos, videoPosition;
    dealImages = carousel.dealImages, forceVideos = carousel.forceVideos, dealVideos = carousel.dealVideos, videoPosition = carousel.videoPosition;
    media = dealImages.slice(0);
    showVideos = forceVideos || DetectFlash.hasFlash || !!(typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.video : void 0);
    if (showVideos && (dealVideos != null ? dealVideos.length : void 0) > 0) {
      media.splice(videoPosition, 0, dealVideos[0]);
    }
    return {
      media: media,
      showVideos: showVideos
    };
  },
  prepareCarouselOptions: function(carousel, currentDealMedia, featuredImage, i18n) {
    var badge, carouselOptions, dealId, el, imageQuality, imageZoom, lazyLoadFeaturedImage, lazyLoadThumbs, mediaHeight, prefetchImages, shouldShowImageBadge, showThumbs;
    dealId = carousel.dealId, el = carousel.el, imageQuality = carousel.imageQuality, imageZoom = carousel.imageZoom, mediaHeight = carousel.mediaHeight, prefetchImages = carousel.prefetchImages, showThumbs = carousel.showThumbs, lazyLoadThumbs = carousel.lazyLoadThumbs, shouldShowImageBadge = carousel.shouldShowImageBadge, badge = carousel.badge, lazyLoadFeaturedImage = carousel.lazyLoadFeaturedImage;
    carouselOptions = {
      collection: currentDealMedia,
      el: el || DEFAULT_EL,
      imageQuality: imageQuality,
      imageZoom: imageZoom,
      mediaHeight: mediaHeight,
      prefetchImages: prefetchImages,
      showThumbs: showThumbs,
      uuid: dealId,
      lazyLoadThumbs: lazyLoadThumbs,
      shouldShowImageBadge: shouldShowImageBadge,
      badge: badge,
      lazyLoadFeaturedImage: lazyLoadFeaturedImage
    };
    if (imageZoom) {
      carouselOptions.imageZoom.hoverZoomText = i18n.t('.hoverToZoom');
    }
    if (featuredImage != null) {
      carouselOptions.featured = currentDealMedia.findWhere({
        baseURL: featuredImage
      });
    }
    return carouselOptions;
  },
  setVideoLoaderFlags: function(showVideos, carousel) {
    var i, len, loadKaltura, loadOoyala, loadYoutube, ref, video;
    loadKaltura = false;
    loadOoyala = false;
    loadYoutube = false;
    if (showVideos && ((typeof kWidget === "undefined" || kWidget === null) || (typeof OO === "undefined" || OO === null) || (typeof YT === "undefined" || YT === null))) {
      ref = carousel.dealVideos || [];
      for (i = 0, len = ref.length; i < len; i++) {
        video = ref[i];
        if (!loadKaltura && video.provider === "KALTURA") {
          loadKaltura = true;
        }
        if (!loadOoyala && video.provider === "OOYALA") {
          loadOoyala = true;
        }
        if (!loadYoutube && video.provider === "YOUTUBE") {
          loadYoutube = true;
        }
      }
    }
    return {
      loadKaltura: loadKaltura,
      loadOoyala: loadOoyala,
      loadYoutube: loadYoutube
    };
  },
  loadVideoScripts: function(carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube) {
    if (loadKaltura && (typeof kWidget === "undefined" || kWidget === null)) {
      $.getScript(carousel.kalturaScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "KALTURA"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
    if (loadOoyala && (typeof OO === "undefined" || OO === null)) {
      $.getScript(carousel.ooyalaScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "OOYALA"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
    if (loadYoutube && (typeof YT === "undefined" || YT === null)) {
      return $.getScript(carousel.youtubeScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "YOUTUBE"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9ncm91cG9uLWRlYWwtY2Fyb3VzZWwvZnJvbnRlbmQvaGVscGVycy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ha2VzaGFyaS9uYXBpc3RyYW5vL2J1aWxkLzE0OTU2NjA4OTgyNDktNDM5Ni9wcm9kdWN0aW9uLTIwMTcuMDUuMjRfMjEuMTkvZGVhbC9tb2R1bGVzL2dyb3Vwb24tZGVhbC1jYXJvdXNlbC9mcm9udGVuZC9oZWxwZXJzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJQSxJQUFBOzs7RUFBQSxNQUFNLENBQUMsZUFBZ0I7OztBQUV2QixVQUFBLEdBQWE7O0FBRWIsWUFBWSxDQUFDLE9BQWIsR0FDRTtFQUFBLFFBQUEsRUFBVSxTQUFDLFFBQUQ7QUFDUixRQUFBO0lBQUMsZ0NBQUQsRUFBYSxrQ0FBYixFQUEwQixnQ0FBMUIsRUFBc0M7SUFHdEMsS0FBQSxHQUFRLFVBQVUsQ0FBQyxLQUFYLENBQWlCLENBQWpCO0lBQ1IsVUFBQSxHQUFhLFdBQUEsSUFBZSxXQUFXLENBQUMsUUFBM0IsSUFBdUMsQ0FBQyxDQUFDLDBEQUFDLFNBQVMsQ0FBRSxjQUFaO0lBRXRELElBQUcsVUFBQSwwQkFBZSxVQUFVLENBQUUsZ0JBQVosR0FBcUIsQ0FBdkM7TUFHRSxLQUFLLENBQUMsTUFBTixDQUFhLGFBQWIsRUFBNEIsQ0FBNUIsRUFBK0IsVUFBVyxDQUFBLENBQUEsQ0FBMUMsRUFIRjs7V0FLQTtNQUFDLE9BQUEsS0FBRDtNQUFRLFlBQUEsVUFBUjs7RUFaUSxDQUFWO0VBY0Esc0JBQUEsRUFBd0IsU0FBQyxRQUFELEVBQVcsZ0JBQVgsRUFBNkIsYUFBN0IsRUFBNEMsSUFBNUM7QUFDdEIsUUFBQTtJQUFDLHdCQUFELEVBQVMsZ0JBQVQsRUFBYSxvQ0FBYixFQUEyQiw4QkFBM0IsRUFBc0Msa0NBQXRDLEVBQW1ELHdDQUFuRCxFQUFtRSxnQ0FBbkUsRUFBK0Usd0NBQS9FLEVBQStGLG9EQUEvRixFQUFxSCxzQkFBckgsRUFBNEg7SUFFNUgsZUFBQSxHQUNFO01BQUEsVUFBQSxFQUFZLGdCQUFaO01BQ0EsRUFBQSxFQUFJLEVBQUEsSUFBTSxVQURWO01BRUEsWUFBQSxFQUFjLFlBRmQ7TUFHQSxTQUFBLEVBQVcsU0FIWDtNQUlBLFdBQUEsRUFBYSxXQUpiO01BS0EsY0FBQSxFQUFnQixjQUxoQjtNQU1BLFVBQUEsRUFBWSxVQU5aO01BT0EsSUFBQSxFQUFNLE1BUE47TUFRQSxjQUFBLEVBQWdCLGNBUmhCO01BU0Esb0JBQUEsRUFBc0Isb0JBVHRCO01BVUEsS0FBQSxFQUFPLEtBVlA7TUFXQSxxQkFBQSxFQUF1QixxQkFYdkI7O0lBYUYsSUFBRyxTQUFIO01BQWtCLGVBQWUsQ0FBQyxTQUFTLENBQUMsYUFBMUIsR0FBMEMsSUFBSSxDQUFDLENBQUwsQ0FBTyxjQUFQLEVBQTVEOztJQUVBLElBQUcscUJBQUg7TUFBdUIsZUFBZSxDQUFDLFFBQWhCLEdBQTJCLGdCQUFnQixDQUFDLFNBQWpCLENBQTJCO1FBQUEsT0FBQSxFQUFTLGFBQVQ7T0FBM0IsRUFBbEQ7O1dBRUE7RUFyQnNCLENBZHhCO0VBcUNBLG1CQUFBLEVBQXFCLFNBQUMsVUFBRCxFQUFhLFFBQWI7QUFDbkIsUUFBQTtJQUFBLFdBQUEsR0FBYztJQUNkLFVBQUEsR0FBYTtJQUNiLFdBQUEsR0FBYztJQUVkLElBQUcsVUFBQSxJQUFlLENBQUUsb0RBQUQsSUFBYywwQ0FBZCxJQUFzQiwwQ0FBdkIsQ0FBbEI7QUFDRTtBQUFBLFdBQUEscUNBQUE7O1FBQ0UsSUFBc0IsQ0FBSSxXQUFKLElBQW9CLEtBQUssQ0FBQyxRQUFOLEtBQWtCLFNBQTVEO1VBQUEsV0FBQSxHQUFjLEtBQWQ7O1FBQ0EsSUFBcUIsQ0FBSSxVQUFKLElBQW1CLEtBQUssQ0FBQyxRQUFOLEtBQWtCLFFBQTFEO1VBQUEsVUFBQSxHQUFhLEtBQWI7O1FBQ0EsSUFBc0IsQ0FBSSxXQUFKLElBQW9CLEtBQUssQ0FBQyxRQUFOLEtBQWtCLFNBQTVEO1VBQUEsV0FBQSxHQUFjLEtBQWQ7O0FBSEYsT0FERjs7V0FNQTtNQUFDLGFBQUEsV0FBRDtNQUFjLFlBQUEsVUFBZDtNQUEwQixhQUFBLFdBQTFCOztFQVhtQixDQXJDckI7RUFrREEsZ0JBQUEsRUFBa0IsU0FBQyxRQUFELEVBQVcsbUJBQVgsRUFBZ0MsV0FBaEMsRUFBNkMsVUFBN0MsRUFBeUQsV0FBekQ7SUFDaEIsSUFBRyxXQUFBLElBQW9CLG9EQUF2QjtNQUNFLENBQUMsQ0FBQyxTQUFGLENBQVksUUFBUSxDQUFDLGdCQUFyQixDQUFzQyxDQUFDLElBQXZDLENBQTRDLFNBQUE7UUFDMUMsbUJBQW1CLENBQUMsVUFBVSxDQUFDLE1BQS9CLENBQXNDLG1CQUFtQixDQUFDLFVBQVUsQ0FBQyxLQUEvQixDQUFxQztVQUFBLFFBQUEsRUFBVSxTQUFWO1NBQXJDLENBQXRDO1FBQ0EsSUFBQSxDQUFBLENBQXFFLG1CQUFtQixDQUFDLFVBQVUsQ0FBQyxPQUFPLENBQUMsT0FBdkMsQ0FBK0Msa0JBQS9DLENBQUEsR0FBcUUsQ0FBQyxDQUEzSSxDQUFBO1VBQUEsbUJBQW1CLENBQUMsVUFBVSxDQUFDLE9BQS9CLElBQTBDLG9CQUExQzs7ZUFDQSxtQkFBbUIsQ0FBQyxNQUFwQixDQUFBO01BSDBDLENBQTVDLEVBREY7O0lBTUEsSUFBRyxVQUFBLElBQW1CLDBDQUF0QjtNQUNFLENBQUMsQ0FBQyxTQUFGLENBQVksUUFBUSxDQUFDLGVBQXJCLENBQXFDLENBQUMsSUFBdEMsQ0FBMkMsU0FBQTtRQUN6QyxtQkFBbUIsQ0FBQyxVQUFVLENBQUMsTUFBL0IsQ0FBc0MsbUJBQW1CLENBQUMsVUFBVSxDQUFDLEtBQS9CLENBQXFDO1VBQUEsUUFBQSxFQUFVLFFBQVY7U0FBckMsQ0FBdEM7UUFDQSxJQUFBLENBQUEsQ0FBcUUsbUJBQW1CLENBQUMsVUFBVSxDQUFDLE9BQU8sQ0FBQyxPQUF2QyxDQUErQyxrQkFBL0MsQ0FBQSxHQUFxRSxDQUFDLENBQTNJLENBQUE7VUFBQSxtQkFBbUIsQ0FBQyxVQUFVLENBQUMsT0FBL0IsSUFBMEMsb0JBQTFDOztlQUNBLG1CQUFtQixDQUFDLE1BQXBCLENBQUE7TUFIeUMsQ0FBM0MsRUFERjs7SUFNQSxJQUFHLFdBQUEsSUFBb0IsMENBQXZCO2FBQ0UsQ0FBQyxDQUFDLFNBQUYsQ0FBWSxRQUFRLENBQUMsZ0JBQXJCLENBQXNDLENBQUMsSUFBdkMsQ0FBNEMsU0FBQTtRQUMxQyxtQkFBbUIsQ0FBQyxVQUFVLENBQUMsTUFBL0IsQ0FBc0MsbUJBQW1CLENBQUMsVUFBVSxDQUFDLEtBQS9CLENBQXFDO1VBQUEsUUFBQSxFQUFVLFNBQVY7U0FBckMsQ0FBdEM7UUFDQSxJQUFBLENBQUEsQ0FBcUUsbUJBQW1CLENBQUMsVUFBVSxDQUFDLE9BQU8sQ0FBQyxPQUF2QyxDQUErQyxrQkFBL0MsQ0FBQSxHQUFxRSxDQUFDLENBQTNJLENBQUE7VUFBQSxtQkFBbUIsQ0FBQyxVQUFVLENBQUMsT0FBL0IsSUFBMEMsb0JBQTFDOztlQUNBLG1CQUFtQixDQUFDLE1BQXBCLENBQUE7TUFIMEMsQ0FBNUMsRUFERjs7RUFiZ0IsQ0FsRGxCIn0=
